import type { UiText } from '@inference.engine/agentic-ui/components';
import i18n from './config';

/** Copy for agentic-ui components, from this app's catalogue with the library's English behind it. */
export const agenticUiText: UiText = (key, fallback, values) =>
  i18n.t(`agentBuilder:ui.${key}` as never, { defaultValue: fallback, ...values });
